import { render, staticRenderFns } from "./Leftmenu.vue?vue&type=template&id=35cf38f4&scoped=true"
import script from "./Leftmenu.vue?vue&type=script&lang=js"
export * from "./Leftmenu.vue?vue&type=script&lang=js"
import style0 from "./Leftmenu.vue?vue&type=style&index=0&id=35cf38f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cf38f4",
  null
  
)

export default component.exports